@let isSaasLocation = isSaasLocation$ | async;

<gb-unauthenticated-shell>
  <!-- MFA Form -->
  @if (showMfaForm$ | async) {
    <form [formGroup]="mfaForm" (ngSubmit)="dispatchMfa()" class="mfa-form">
      <div>
        <h2 translate="AUTH.LOGIN.MFA_HEADER"></h2>
        <gb-verify-code-form-field
          [control]="mfaCode"
          labelTranslateKey="AUTH.LOGIN.MFA_PROMPT"
          (lastDigitEntered)="dispatchMfa()"
        ></gb-verify-code-form-field>
      </div>
      <button mat-flat-button translate="AUTH.LOGIN.SUBMIT"></button>
    </form>
  }
  <!-- Login Form -->
  @else {
    @if (!(shouldShowDistributorInput$ | async)) {
      <div class="login-header-container">
        <div class="social-login-container">
          <gb-social-login-register [type]="'login'"></gb-social-login-register>
        </div>
        <div class="or-div">
          <span translate="OR"></span>
        </div>
      </div>
    }
    <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm()" class="login-form">
      <gb-form-field [control]="email" type="email" labelTranslateKey="AUTH.LOGIN.EMAIL_LABEL"></gb-form-field>
      <gb-form-field [control]="password" type="password" labelTranslateKey="AUTH.LOGIN.PASSWORD_LABEL"></gb-form-field>
      @if (shouldShowDistributorInput$ | async) {
        <gb-form-field [control]="distributor" labelTranslateKey="AUTH.LOGIN.DISTRIBUTOR_LABEL"></gb-form-field>
      }
      <gb-grecaptcha class="recaptcha-container" (recaptchaSuccess)="grecaptchaCallback($event)"> </gb-grecaptcha>
      <div>
        <button mat-flat-button translate="AUTH.LOGIN.SUBMIT"></button>
        <a class="link" [gbRouteNewTab]="'/' + ForgotPasswordConstants.FORGOT_PASSWORD">
          <span translate="AUTH.LOGIN.FORGOT_PASSWORD"></span>
        </a>

        @if (isSaasLocation !== null) {
          <div class="signup-now">
            <span translate="AUTH.LOGIN.DONT_HAVE_AN_ACCOUNT"></span>
            @if (isSaasLocation) {
              <a [gbRouteNewTab]="'/' + RegisterConstants.REGISTER">
                <span translate="AUTH.LOGIN.SIGN_UP_NOW"></span>
              </a>
            } @else {
              <a [href]="appConfig.gbContactUrl" target="_blank" rel="noopener noreferrer">
                <span translate="AUTH.LOGIN.CONTACT_US"></span>
              </a>
            }
          </div>
        }
      </div>
    </form>
  }
</gb-unauthenticated-shell>
